import React from 'react'
import Cookie from '../Cookie'
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux";
import ContactInfo from '../Header/ContactInfo';


const Footer = () => {
    let dispatch = useDispatch();

    let cookie = useSelector((state) => state.settings.cookie);

    const cancelCookie = () => {
        dispatch({ type: "settings/cookie" })
    }

    const acceptCookie = () => {
        // Write your function there
        dispatch({ type: "settings/cookie" })
    }

    return (
        <>
         <section id="copyright_one" style={{ backgroundI: "black", padding: "20px 0" }}>
    <div className="container">
        <ContactInfo textColor="white" />
        <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12 text-center text-md-left mb-2 mb-md-0">
                <div className="copyright_left">
                    <h6 style={{ color: "#fff", fontSize: "14px", margin: "0" }}>
                        © Copyright {new Date().getFullYear()}
                    </h6>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-center text-md-right">
                <div className="copyright_right" style={{ color: "white", fontSize: "14px" }}>
                    Developed and Maintained By
                    <a href="https://www.pinnaclesystems.co.in/" target="_blank" className="ml-1" 
                       style={{ textDecoration: "underline", color: "#FFD700", fontWeight: "500", marginLeft: "5px" }} 
                       rel="noreferrer noopener">
                        Pinnacle Systems
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

            {
                cookie ? <Cookie accept={acceptCookie} cancel={cancelCookie} /> : null
            }
        </>
    )
}

export default Footer